module.exports = __webpack_public_path__ + "img/ИФ-1(А)-009.9ac2b123.png";